module.exports = __webpack_public_path__ + "static/img/c1.3eb9b01.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/c1.png
// module id = 5Gw3
// module chunks = 0